import React from 'react';
import Item from '../Item';
import { ReactComponent as HotelIcon } from '../../../../../resource/HotelIcon.svg';

const BaseRoomItem = ({ room, action, info, children, onClick, disabled }) => {
  return (
    <Item
      title={`№ ${room.flat}`}
      note={room.typeName}
      iconComponent={HotelIcon}
      description={room.stepAddressLifeCycle?.name}
      action={action}
      info={info}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Item>
  );
};

export default BaseRoomItem;
